import { apiV3Client } from './BaseRepository';

export function fetchGlobalInsightSupplyList(supplyFilter = {}) {
  return apiV3Client.post('candidates/_distributionstats', supplyFilter);
}
